import Image from '@tiptap/extension-image';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import ImageResize from './ImageResize.vue';

const CustomImage = Image.extend({
    name: 'CustomImage',
    addAttributes() {
        return {
            ...this.parent?.(),
            src: {
                default: '',
                renderHTML: attributes => {
                    return {
                        src: attributes.src,
                    };
                },
            },
            'data-id': {
                default: '',
                renderHTML: attributes => {
                    return {
                        'data-id': attributes['data-id'],
                    };
                },
            },
            width: {
                default: 750,
                renderHTML: ({ width }) => ({ width }),
            },
            height: {
                default: 500,
                renderHTML: ({ height }) => ({ height }),
            },
            isDraggable: {
                default: true,
                renderHTML: attributes => {
                    return {};
                },
            },
        };
    },
    addNodeView() {
        return VueNodeViewRenderer(ImageResize);
    },
});

export { CustomImage };
export default CustomImage;